import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { TestimonialsSection } from './TestimonialsSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FooterSection } from './FooterSection';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-121">
      <HeroSection data-id="element-122" />
      <ProblemSection data-id="element-123" />
      <SolutionSection data-id="element-124" />
      <BeforeAfterSection data-id="element-125" />
      <BonusSection data-id="element-126" />
      <TestimonialsSection data-id="element-127" />
      <PricingSection data-id="element-128" />
      <GuaranteeSection data-id="element-129" />
      <FooterSection data-id="element-130" />
    </div>;
}